import { Order } from 'src/models';

import { MButton } from '../MButton/MButton';
import * as Styles from '../ViewDetailsButton/ViewDetailsButton.styles';

interface ChangeOrderButtonProps {
  value: Order;
  onClick: (order: Order) => void;
}

export const ChangeOrderButton = ({ value, onClick }: ChangeOrderButtonProps) => {
  if (!value.status.isWorking || value.type.isMarket) {
    return null;
  }

  return (
    <MButton
      type='tertiary'
      className={Styles.viewDetailsButton}
      onClick={() => onClick(value)}
      testId={`order-${value.id}-change`}>
      Change
    </MButton>
  );
};
